<div class="flex-column flex-center">
  <p class="hint">
    {{ data.message }}
  </p>
  <button mat-raised-button color="primary" mat-dialog-close>Ok</button>
</div>
